/**
 * Formatta un valore in secondi come MM:SS o MM:SS.mmm
 * @param {number} value - Durata in secondi (può essere decimale)
 * @param {boolean} [noMilliseconds] - Se true, omette i millisecondi
 * @returns {string} Stringa formattata (es. "01:23" o "01:23.456")
 */
export const formatTime = (value, noMilliseconds) => {
  const minutes = Math.floor(value / 60)
  const seconds = Math.floor(value - minutes * 60)
  const milliseconds = Math.floor((value - minutes * 60 - seconds) * 1000)
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}${noMilliseconds ? '' : `.${milliseconds.toString().padStart(3, '0')}`}`
}
